export default "__VITE_ASSET__BKAsZZqi__"